import { RotatingTriangles } from "react-loader-spinner";

export const Loader = () => {
  return (
    <div className={'flex items-center justify-center h-dvh'}>
      <RotatingTriangles
        visible={true}
        height="80"
        width="80"
        ariaLabel="rotating-triangles-loading"
      />
    </div>
  )
}
